import request from '@/utils/request'

// 错题本

let QuestionErrorrankingLogApi = {
    
    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.question_errorranking_log/index', data, errorback);
    },

    /*错题排行榜*/
    ranking(data, errorback) {
        return request._post('/shop/study.question_errorranking_log/ranking', data, errorback);
    },

    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.question_errorranking_log/batch', data, errorback);
    },

}

export default QuestionErrorrankingLogApi;



// WEBPACK FOOTER //
// ./src/api/study/question_errorranking_log.js